import { inject, Injectable } from "@angular/core";
import { EntityApiService } from "../../../../shared/store/entity-store/entity-api.service";
import { map, Observable } from "rxjs";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../../../../environments/environment";
import { QueryParam } from "../../../../shared/store/store-types.model";
import { Pass } from "../../models/pass.model";
import { safeFirstValueFrom } from "../../../../shared/utils/safe-first-value-from";

@Injectable({
  providedIn: "root",
})
export class PassApiService implements EntityApiService<Pass> {
  http = inject(HttpClient);

  constructor() {}

  loadAll(query?: QueryParam): Observable<Pass[]> {
    return this.http.get<Pass[]>(`${environment.api()}/pass`);
  }

  create(entity: Pass): Observable<Pass> {
    return this.http.post<Pass>(`${environment.api()}/pass`, entity);
  }

  remove(id: string): Observable<string> {
    return this.http.delete(`${environment.api()}/pass/${id}`).pipe(map(res => id));
  }

  update(entity: Pass): Observable<Pass> {
    return this.http.post<Pass>(`${environment.api()}/pass`, entity);
  }

  loadOne(id: string, query?: QueryParam): Observable<Pass> {
    return this.http.get<Pass>(`${environment.api()}/pass/${id}`);
  }

  async inheritPass(denomination: string, id: string) {
    return await safeFirstValueFrom(
      this.http.post<Pass>(`${environment.api()}/pass/inherit`, {
        denomination,
        id,
      }),
    );
  }
}
